// UI-facing guardrail constants for the video-to-gif tool — mirrors
// be/src/config/converterLimits.ts so slider clamps match what the server
// actually enforces. The server re-clamps everything defensively regardless;
// these are only for a sane, honest UI, never trust the client alone.

export const VIDEO_MAX_UPLOAD_BYTES = 500 * 1024 * 1024
// Separate from MAX_TRIM_DURATION_SEC (which bounds the PROCESSED segment
// regardless of source length) — this caps the SOURCE video itself, mainly so
// filmstrip thumbnail generation (16 sequential seeks) and scrubbing stay
// practical; without it, a multi-hour upload would still only ever convert a
// MAX_TRIM_DURATION_SEC-sized slice, but the trim UI itself would be unusable.
export const MAX_VIDEO_DURATION_SEC = 30 * 60
export const VIDEO_ALLOWED_TYPES = new Set(['video/mp4', 'video/webm', 'video/quicktime'])
export const VIDEO_INPUT_ACCEPT = 'video/mp4,video/webm,video/quicktime'

export const MAX_TRIM_DURATION_SEC = 300

export const MIN_OUTPUT_LONG_EDGE_PX = 160
export const MAX_OUTPUT_LONG_EDGE_PX = 960
export const DEFAULT_OUTPUT_LONG_EDGE_PX = 480

export const MIN_OUTPUT_FPS = 5
export const MAX_OUTPUT_FPS = 20
export const DEFAULT_OUTPUT_FPS = 10

/** GIF palette size — the main quality/size lever for palette-based GIF output. */
export const MIN_GIF_COLORS = 32
export const MAX_GIF_COLORS = 256
export const DEFAULT_GIF_COLORS = 256

/** How often the FE polls GET /converter/jobs/:id for real progress. */
export const JOB_POLL_INTERVAL_MS = 800
